import * as R from 'ramda';

export const getUri = R.pipe(R.propOr('', 'pathname'), R.replace(/\/$/, ''));
